import React from "react";
import { Icon } from "@iconify/react";

const InfoCard = ({ title, count, bg, icon, color }) => {
  return (
    <div
      className="p-3 shadow-sm h-100"
      style={{
        borderRadius: "14px",
        background: "#fff",
        display: "flex",
        alignItems: "center",
        gap: "15px",
         border: "1px solid #DDDDDD", 
      }}
    >
      {/* Icon box */}
      <div
        style={{
          background: bg,
          padding: "12px",
          borderRadius: "12px",
          flexShrink: 0, // prevents icon from shrinking on small screens
        }}
      >
        <Icon icon={icon} width="26" height="26" color={color} />
      </div>

      {/* Text section */}
      <div style={{ minWidth: 0 }}>
        <p
          className="text-truncate"
          style={{
            margin: 0,
            fontSize: "14px",
            fontWeight: 500,
            color: "#555",
          }}
        >
          {title}
        </p>

        <p
          style={{
            margin: 0,
            fontSize: "22px",
            fontWeight: 600,
          }}
        >
          {count}
        </p>
      </div>
    </div>
  );
};

export default InfoCard;